import type { ReactNode } from 'react';
import { Tabs as UiTabs } from '@ledgerloom/ui';

// Tabs with the arrow-key path (the library's): Left and Right move between tabs,
// Home and End jump to the ends. The children are the current tab's panel, a whole
// section of the page, so the panel draws no card of its own. Pattern: navigation/tabs.
export function Tabs<T extends string>({ label, value, tabs, onChange, children }: { label: string; value: T; tabs: Array<[T, string]>; onChange: (v: T) => void; children: ReactNode }) {
  return (
    <UiTabs
      label={label}
      value={value}
      onValueChange={(v) => onChange(v as T)}
      items={tabs.map(([v, text]) => ({ value: v, label: text, content: v === value ? children : null }))}
      className="gap-3"
      panelClassName="min-w-0"
    />
  );
}
